export const sortBy = <T>(arr: T[], key: keyof T | [keyof T]) => {
    const k = Array.isArray(key) ? key[0] : key;
    return [...arr].sort((a, b) => (a[k] < b[k] ? -1 : a[k] > b[k] ? 1 : 0));
};

export const findLastIndex = <T>(arr: T[], predicate: (item: T) => boolean) => {
    for (let i = arr.length - 1; i >= 0; i--) {
        const item = arr[i];
        if (item !== undefined && predicate(item)) return i;
    }
    return -1;
};

export const nth = <T>(arr: T[], n: number): T | undefined => (n < 0 ? arr[arr.length + n] : arr[n]);

export const debounce = <T extends (...args: unknown[]) => void>(fn: T, ms: number) => {
    let timer: ReturnType<typeof setTimeout>;
    return (...args: Parameters<T>) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), ms);
    };
};

export const groupBy = <T>(arr: T[], fn: (item: T) => string | undefined) =>
    arr.reduce<Record<string, T[]>>((acc, item) => {
        const key = fn(item) ?? 'undefined';
        (acc[key] ??= []).push(item);
        return acc;
    }, {});
